<script setup>
import { ref, onMounted } from 'vue'
import { useMainStore } from '@/stores/useMainStore.js'
import { bestaetigenLegacy } from '@/api/LegacyService.js'

import Loader from '@/components/loader.vue'
import legacy_erfolgreich from '@/components/legacy_erfolgreich.vue'
import legacy_fehler from '@/components/legacy_fehler.vue'

const mainStore = useMainStore()

// Status: 'loading', 'success', 'error'
const status = ref('loading')
const fehlermeldung = ref('')

onMounted(async () => {
    const code1 = mainStore.code1
    const code2 = mainStore.code2
    const kanal = mainStore.kanal
    const funktion = mainStore.funktion

    console.log('[Legacy] Bestätigung mit code1:', code1, 'code2:', code2, 'kanal:', kanal, 'funktion:', funktion)

    if (!code1) {
        status.value = 'error'
        fehlermeldung.value = 'Kein Bestätigungscode gefunden.'
        return
    }

    const result = await bestaetigenLegacy(code1, code2, kanal, funktion)

    if (result.success) {
        status.value = 'success'
    } else {
        status.value = 'error'
        fehlermeldung.value = result.nachricht
    }
})
</script>

<template>
    <div>
        <!-- Loader während des API-Calls -->
        <Loader v-if="status === 'loading'" />
        
        <!-- Erfolgsseite -->
        <legacy_erfolgreich v-else-if="status === 'success'" />
        
        <!-- Fehlerseite mit dynamischer Fehlermeldung -->
        <legacy_fehler v-else :fehlermeldung="fehlermeldung" />
    </div>
</template>
